// @ts-nocheck
import './BrandedAccountLoader.css';
import { PRODUCTION_PRODUCT_MODE } from '../lib/product-mode.ts';

const desktopInfinityPath = 'M 120 50 C 120 22.386 97.614 0 70 0 C 42.386 0 20 22.386 20 50 C 20 77.614 42.386 100 70 100 C 97.614 100 120 77.614 120 50 C 120 22.386 142.386 0 170 0 C 197.614 0 220 22.386 220 50 C 220 77.614 197.614 100 170 100 C 142.386 100 120 77.614 120 50';
const mobileInfinityPath = 'M 50 100 C 22.386 100 0 77.614 0 50 C 0 22.386 22.386 0 50 0 C 77.614 0 100 22.386 100 50 C 100 77.614 77.614 100 50 100 C 22.386 100 0 122.386 0 150 C 0 177.614 22.386 200 50 200 C 77.614 200 100 177.614 100 150 C 100 122.386 77.614 100 50 100';
const keshaCirclePath = 'M 50 0 A 50 50 0 1 1 49.999 0';

function InfinityLine({ path }) {
  return (
    <>
      <path className="branded-account-loader__infinity-path branded-account-loader__infinity-rail" d={path} pathLength="100" />
      <path className="branded-account-loader__infinity-path branded-account-loader__infinity-glow" d={path} pathLength="100" />
      <path className="branded-account-loader__infinity-path branded-account-loader__infinity-traveler-glow" d={path} pathLength="100" />
      <path className="branded-account-loader__infinity-path branded-account-loader__infinity-traveler" d={path} pathLength="100" />
    </>
  );
}

export default function BrandedAccountLoader({ variant = 'full', label = 'Loading your account', className = '', keshaSrc = '/kesha_agent.webp', user = null }) {
  const keshaOnly = variant === 'kesha-only';
  const userName = String(user?.name || user?.displayName || '').trim();
  const nameParts = userName.split(/\s+/).filter(Boolean);
  const userInitials = nameParts.length > 1
    ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase()
    : (nameParts[0] || String(user?.email || '').trim()).slice(0, 2).toUpperCase();
  let storedInitials = '';
  try {
    storedInitials = typeof window !== 'undefined' ? window.localStorage.getItem('ac_account_loader_initials') || '' : '';
  } catch {}
  const initials = userInitials || storedInitials || 'AC';

  return (
    <div className={`branded-account-loader${keshaOnly ? ' branded-account-loader--kesha-only' : ''}${className ? ` ${className}` : ''}`} role="status" aria-live="polite" aria-label={label}>
      <div className="branded-account-loader__glow branded-account-loader__glow--left" aria-hidden="true" />
      <div className="branded-account-loader__glow branded-account-loader__glow--right" aria-hidden="true" />
      <div className="branded-account-loader__content">
        <div className="branded-account-loader__marks">
          {!keshaOnly ? (
            <div className="branded-account-loader__mark branded-account-loader__mark--logo">
              <img src="/logo-aic-dark.webp" alt="Artificial Career" className="branded-account-loader__logo branded-account-loader__logo--dark" />
              <img src="/logo-aic-light.webp" alt="Artificial Career" className="branded-account-loader__logo branded-account-loader__logo--light" />
            </div>
          ) : null}
          <div className="branded-account-loader__connector" aria-hidden="true">
            {keshaOnly ? (
              <>
                <svg className="branded-account-loader__infinity branded-account-loader__infinity--desktop" viewBox="0 0 100 100" focusable="false">
                  <InfinityLine path={keshaCirclePath} />
                </svg>
                <svg className="branded-account-loader__infinity branded-account-loader__infinity--mobile" viewBox="0 0 100 100" focusable="false">
                  <InfinityLine path={keshaCirclePath} />
                </svg>
              </>
            ) : (
              <>
                <svg className="branded-account-loader__infinity branded-account-loader__infinity--desktop" viewBox="0 0 240 100" preserveAspectRatio="none" focusable="false">
                  <InfinityLine path={desktopInfinityPath} />
                </svg>
                <svg className="branded-account-loader__infinity branded-account-loader__infinity--mobile" viewBox="0 0 100 200" preserveAspectRatio="none" focusable="false">
                  <InfinityLine path={mobileInfinityPath} />
                </svg>
              </>
            )}
          </div>
          <div className={`branded-account-loader__mark branded-account-loader__mark--${PRODUCTION_PRODUCT_MODE ? 'user' : 'kesha'}`}>
            {PRODUCTION_PRODUCT_MODE ? (
              <span className="branded-account-loader__user-avatar" aria-hidden="true">{initials}</span>
            ) : <img src={keshaSrc} alt={keshaOnly ? '' : 'Kesha'} fetchPriority="high" decoding="async" />}
          </div>
        </div>
        <span className="branded-account-loader__dots" aria-hidden="true"><i /><i /><i /></span>
      </div>
    </div>
  );
}
